module.exports = __webpack_public_path__ + "img/waterluxe-logo-black.1ba28c9e.svg";